import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../Context/AuthProvider";
import { useEffect } from "react";
import axios from "axios";
import { url } from "../../../Constant";
import { useState } from "react";
import { toast } from "react-toastify";
import $ from "jquery";
import { checkIndividualPermission } from "../../../Utils/PermissionFunctions";

const NewRouting = () => {
  const { auth } = useAuth();
  const [errorEnable, setErrorEnable] = useState(false);
  const [similarError, setSimilarError] = useState(false);
  const [loader, setLoader] = useState(false);
  const [groupsDropdpown, setGroupsDropdwpon] = useState();
  const [extesnionNumber, setExtesnionNumber] = useState();
  const [routingMode, setRoutingMode] = useState("");
  const [group, setGroup] = useState("");
  const [errorArray, setErrorArray] = useState([]);

  const getGroups = () => {
    let data = {
      package_id: auth.package_id,
      template_name: auth.template_name,
      vpbx_id: auth.vpbx_id,
    };
    axios
      .post(url + "get-groups", data, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            if (response.data.message === "Data Found") {
              setGroupsDropdwpon(response?.data?.data?.group_drop_down);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const getExtesnionNmuber = () => {
    let data = {
      group_name: group,
      vpbx_id: auth.vpbx_id,
    };
    let api = "";
    if (auth.role === "2") {
      api = "get_extension_number";
    } else {
      api = "user-get_extension_number";
    }
    axios
      .post(url + api, data, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            if (response.data.message === "Data Found") {
              setExtesnionNumber(response?.data?.data?.extension_numbers);
              setErrorArray([""]);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  useEffect(() => {
    if (
      auth.role === "1" ||
      (auth.role === "3" &&
        !checkIndividualPermission("routing", "read_and_write"))
    ) {
      window.location.href = "/";
    }
    getGroups();
  }, []);
  useEffect(() => {
    if (routingMode === "priority" && group !== "") {
      getExtesnionNmuber();
    } else {
      setExtesnionNumber([]);
    }
  }, [routingMode, group]);

  const addRouting = () => {
    var tempErrorArray = [];
    var newData = false;
    setErrorEnable(true);
    setLoader(true);
    let arrayVal = [];
    if (extesnionNumber?.length > 0) {
      for (let i = 0; i < extesnionNumber.length; i++) {
        arrayVal.push($(`#extesnions${i}`).val());
      }
      const containEmptyString = (element) => element === "";
      tempErrorArray = arrayVal.filter(containEmptyString);
      setErrorArray(tempErrorArray);
      function hasDuplicates(array) {
        return new Set(array).size !== array.length;
      }
      newData = hasDuplicates(arrayVal);
      if (newData === true) {
        setSimilarError(true);
      } else {
        setSimilarError(false);
      }
    } else {
      setErrorArray([]);
      arrayVal = [];
    }

    let data = {
      vpbx_id: auth.vpbx_id,
      group_name: group,
      mode: routingMode,
      extensions: arrayVal,
    };

    if (
      group !== "" &&
      routingMode !== "" &&
      tempErrorArray.length === 0 &&
      newData === false
    ) {
      let api = "";
      if (auth.role === "2") {
        api = "save_route_priority";
      } else {
        api = "user-save_route_priority";
      }

      axios
        .post(url + api, data, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.status === 200) {
              // if (response.data.message === "Priority update Successfully") {
              setLoader(false);
              toast.success("Routing Added Successfully", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
              setTimeout(() => {
                window.location.href = "/vpbx-manager";
              }, 2000);
              // }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div>
      <div className="dashboardWrp">
        <div className="uk-container uk-container-small">
          <div className="dashboardTop">
            <div uk-grid="" className="uk-grid uk-grid-small">
              <div className="uk-width-2-3">
                <div className="dashboardIntro">
                  <Link to="/vpbx-manager">
                    <img
                      src="./assets/images/zong/chevron--left.svg"
                      uk-svg=""
                    />
                    <span>Back to VPBX manager</span>
                  </Link>
                  <h3>Create Call Routing</h3>
                  <p>
                    Create a new call routing by selecting the desired
                    department and assigning extensions in your preferred
                    sequence.
                  </p>
                </div>
              </div>
              {/* <div className="uk-width-1-3">
              <div className="dashboardIntro uk-text-right">
                <button>EXPORT DATA</button>
              </div>
            </div> */}
            </div>

            <form action="javascript:void(0);">
              <div className="formCreateMain">
                <div className="uk-grid uk-grid-small">
                  <div className="uk-width-1-1@m uk-margin-top">
                    <legend className="uk-legend">Call Routing Settings</legend>
                  </div>
                  <div className="uk-width-1-2@m uk-margin-top">
                    <label>Department</label>
                    <select
                      className="uk-select"
                      aria-label="Select"
                      onChange={(e) => setGroup(e.target.value)}
                    >
                      <option value="" selected disabled hidden>
                        Select a number...
                      </option>
                      {groupsDropdpown?.map((val, index) => {
                        return (
                          <option key={index} value={val?.group_name}>
                            {val?.group_name}
                          </option>
                        );
                      })}
                    </select>
                    {errorEnable && group === "" && (
                      <di className="formErrors">department is required</di>
                    )}
                  </div>
                  <div className="uk-width-1-1@m uk-margin">
                    <label>
                      <b>Routing mode</b>
                    </label>
                    {/* <label className="CheckBoxLabel">
                      <input className="uk-checkbox" type="checkbox" />{" "}
                      <input
                        type="radio"
                        id="html"
                        name="fav_language"
                        value="ring_all"
                        onChange={(e) => setRoutingMode(e.target.value)}
                      />
                      <span>Ring all</span>
                    </label> */}

                    <label className="CheckBoxLabel">
                      {/* <input className="uk-checkbox" type="checkbox" />{" "} */}
                      <input
                        type="radio"
                        id="html"
                        name="fav_language"
                        value="sequencing"
                        onChange={(e) => setRoutingMode(e.target.value)}
                      />
                      <span>Round robin</span>
                    </label>

                    <label className="CheckBoxLabel">
                      {/* <input className="uk-checkbox" type="checkbox" />{" "} */}
                      <input
                        type="radio"
                        id="html"
                        name="fav_language"
                        value="priority"
                        onChange={(e) => setRoutingMode(e.target.value)}
                      />
                      <span>Priority</span>
                    </label>
                    {errorEnable && routingMode === "" && (
                      <di className="formErrors">please select routing mode</di>
                    )}
                  </div>

                  {extesnionNumber?.length > 0 &&
                    extesnionNumber?.map((val, index) => {
                      return (
                        <div key={index} className="uk-width-1-2@m uk-margin">
                          <label>Extension {index + 1}</label>
                          <select
                            className="uk-select"
                            aria-label="Select"
                            id={`extesnions${index}`}
                          >
                            <option value="" selected>
                              Select a number...
                            </option>
                            {extesnionNumber.map((item, inde) => {
                              return (
                                <option key={inde} value={item}>
                                  {item}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      );
                    })}
                  {errorArray.length > 0 &&
                  errorEnable &&
                  extesnionNumber.length > 0 ? (
                    <div className="formErrors">
                      please select all extesnions
                    </div>
                  ) : (
                    ""
                  )}
                  <br />
                  {similarError === true &&
                  errorArray.length === 0 &&
                  errorEnable &&
                  extesnionNumber.length >= 0 ? (
                    <div className="formErrors">
                      Please select different extesnion, each extesnion has its
                      own priority
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="uk-width-1-1@m uk-float-right">
                    <div className="formActionBtn uk-text-right">
                      {/* <button className="whiteBtn">Cancel</button> */}
                      <button className="pinkBtn" onClick={addRouting}>
                        {loader ? (
                          <div uk-spinner="" className="loader">
                            Adding
                          </div>
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewRouting;
